(() => {
    function updateConsent() {
        const privacy = window.Shopify?.customerPrivacy;
        if (!privacy) return;
        const allowed = privacy.analyticsProcessingAllowed();
        const changed = window.codaleAnalyticsAllowed !== allowed;
        window.codaleAnalyticsAllowed = allowed;
        const marketing = privacy.marketingAllowed();
        const sharing = marketing && privacy.saleOfDataAllowed();
        window.gtag('consent', 'update', {
            analytics_storage: allowed ? 'granted' : 'denied',
            ad_storage: marketing ? 'granted' : 'denied',
            ad_user_data: sharing ? 'granted' : 'denied',
            ad_personalization: sharing ? 'granted' : 'denied'
        });
        if (changed) document.dispatchEvent(new CustomEvent('codale:consent'));
    }
    document.addEventListener('visitorConsentCollected', updateConsent);
    if (window.Shopify?.customerPrivacy) updateConsent();
    else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.2' }], error => {
        if (!error) updateConsent();
    });
})();
